/*eslint-disable*/
import { combineReducers } from "redux";
import sectionReducer from "./survey.reducer";
import { LocalUserReducer, UsersReducer } from "./users.reducer";
import { reducer as modal } from "redux-modal";
import TeamsReducer from "./teams.reducer";
import { FundsReducer } from "./funds.reducers";
import { RiskReducer } from "./risk.reducer";
import { DocumentReducer } from "./document.reducer";
import { ToastReducer } from "./toasts.reducers";

export default combineReducers({
  Surveys: sectionReducer,
  LocalUser: LocalUserReducer,
  Users: UsersReducer,
  Teams: TeamsReducer,
  Funds: FundsReducer,
  Toasts: ToastReducer,
  Risk: RiskReducer,
  Documents: DocumentReducer,
  modal,
});
